import { Clock, Users, Plus, X } from "lucide-react";

export default function HabitCard({ habit, categoryLabel, added, onAdd, onRemove, onOpen }) {
  return (
    <article
      className="card-editorial p-6 flex flex-col gap-4 hover:-translate-y-0.5 transition-transform duration-200"
      data-testid={`habit-card-${habit.id}`}
    >
      <div className="flex items-center justify-between">
        <span className="tag-pill">{categoryLabel || habit.category}</span>
        <span className="data-mono">{habit.durationMin}m</span>
      </div>
      <div>
        <h3 className="font-serif text-2xl text-stone-900 leading-tight">{habit.title}</h3>
        <p className="text-sm text-stone-600 mt-1.5 leading-relaxed">{habit.description}</p>
      </div>
      <div className="flex items-center justify-between text-xs text-stone-500 font-sans">
        <span className="inline-flex items-center gap-1.5"><Clock size={13} /> default {habit.defaultStart}</span>
        <span className="inline-flex items-center gap-1.5"><Users size={13} /> {habit.members} keep this</span>
      </div>
      <div className="flex items-center gap-2 pt-2 border-t border-stone-100">
        {added ? (
          <button
            className="btn-outline flex-1 hover:!bg-red-50 hover:!text-red-700 hover:!border-red-300"
            onClick={onRemove || onOpen}
            data-testid={`habit-remove-${habit.id}`}
            title="Remove from your list"
          >
            <X size={16} /> Remove from list
          </button>
        ) : (
          <button
            className="btn-accent flex-1"
            onClick={onAdd}
            data-testid={`habit-add-${habit.id}`}
          >
            <Plus size={16} /> Add to my rhythm
          </button>
        )}
      </div>
    </article>
  );
}
